import { zodResolver } from '@hookform/resolvers/zod';
import { Group, Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ErasmusTypeSelectControl } from '@/module/Travel/Request/components/form/ErasmusTypeSelectControl';

import { Content, DateInputControl, Form, FormSubmit } from '@/core/components';

import { MobilitySchema } from './model/MobilitySchema';

interface MobilityFormProps extends FormSubmit<MobilitySchema> {
  title: string;
}

export function MobilityForm(props: MobilityFormProps) {
  const { title, schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();

  const form = useForm<MobilitySchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <Form
        title={title}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Stack>
          <Content type="full">
            <ErasmusTypeSelectControl
              name="type"
              label={t('mobilities.form.fields.type')}
              isSubmitting={isSubmitting}
              withAsterisk
              control={form.control}
            />
            <Group grow>
              <DateInputControl
                name="startDate"
                label={t('mobilities.form.fields.startDate')}
                isSubmitting={isSubmitting}
                withAsterisk
                control={form.control}
              />
              <DateInputControl
                name="endDate"
                label={t('mobilities.form.fields.endDate')}
                isSubmitting={isSubmitting}
                withAsterisk
                control={form.control}
              />
            </Group>
          </Content>
        </Stack>
      </Form>
    </FormProvider>
  );
}
